import React, { useEffect, useState } from 'react';

function authHeaders() {
  const tok = (typeof localStorage !== 'undefined') && localStorage.getItem('token');
  return tok ? { 'Authorization': `Bearer ${tok}` } : {};
}

function fmtPct(n) {
  if (n == null) return '—';
  return `${(n * 100).toFixed(0)}%`;
}

export default function RiskTuningPage() {
  const [summary, setSummary] = useState(null);
  const [hits, setHits] = useState([]);
  const [keywords, setKeywords] = useState([]);

  useEffect(() => {
    const common = { credentials: 'include', headers: authHeaders() };
    (async () => {
      const [s, h, k] = await Promise.all([
        fetch('/api/admin/risk-tuning/summary?days=7', common),
        fetch('/api/admin/risk-tuning/keyword-hits?days=7', common),
        fetch('/api/admin/risk-tuning/keywords', common),
      ]);
      if (s.ok) setSummary(await s.json());
      if (h.ok) setHits((await h.json()).items || []);
      if (k.ok) setKeywords((await k.json()).keywords || []);
    })();
  }, []);

  const toggleEnabled = async (id, enabled) => {
    const res = await fetch(`/api/admin/risk-tuning/keywords/${id}`, {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify({ enabled }),
    });
    if (res.ok) setKeywords(prev => prev.map(k => k.id === id ? { ...k, enabled } : k));
  };

  if (!summary) return <div>로딩…</div>;

  return (
    <div className="admin-risk-tuning">
      <h2>위험 신호 튜닝 대시보드</h2>
      <section>
        <h3>지난 7일 요약</h3>
        <p>총 감지: {summary.total} | 확인: {summary.confirmed} |
           오탐지: {summary.false_positive} | 미확인: {summary.unreviewed}</p>
        <p>오탐률: {fmtPct(summary.overall_false_positive_rate)} (목표 &lt; 15%)</p>
      </section>

      <section>
        <h3>오탐 빈도 상위 키워드</h3>
        <table>
          <thead>
            <tr><th>키워드</th><th>감지</th><th>오탐</th><th>오탐률</th></tr>
          </thead>
          <tbody>
            {hits.map(h => (
              <tr key={h.keyword}>
                <td>{h.keyword}</td>
                <td>{h.hits}</td>
                <td>{h.false_positive}</td>
                <td>{h.hits > 0 ? fmtPct(h.false_positive / h.hits) : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section>
        <h3>카테고리별 오탐률</h3>
        <ul>
          {Object.entries(summary.byCategory).map(([cat, v]) => (
            <li key={cat}>
              {cat}: {v.false_positive}/{v.confirmed + v.false_positive}
              {' = '}{fmtPct(v.false_positive_rate)}
            </li>
          ))}
        </ul>
      </section>

      <section>
        <h3>키워드 관리</h3>
        <table>
          <thead>
            <tr><th>키워드</th><th>카테고리</th><th>정규식</th><th>활성</th><th>조치</th></tr>
          </thead>
          <tbody>
            {keywords.map(k => (
              <tr key={k.id}>
                <td>{k.keyword}</td>
                <td>{k.category}</td>
                <td>{k.isRegex ? '예' : '아니오'}</td>
                <td>{k.enabled ? '✓' : '✗'}</td>
                <td>
                  <button onClick={() => toggleEnabled(k.id, !k.enabled)}>
                    {k.enabled ? '비활성화' : '활성화'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
}
